import React from 'react';
import get from 'lodash/get';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';

import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Box from '../../../components/molecules/Box';
import useStyles from './style';
import MapViewer from '../../../components/molecules/MapViewer';
import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { getHelperKeysFromDictionary } from '../../../../utils/utility';
import { evalConditionForInsideChina } from '../../../utils/cookie';
import { LANGUAGE_CODE } from '../../../../constants';
import { COMPONENT_NAME } from './locators';
import { dictionaryKeys } from '../BranchesMap/BranchesMap';
import { getComponentName, getPageName } from '../../../utils/getPageComponentInfo';
import { EVENT_TYPE } from '../../../../constants/index';
import { pageContentType } from '../../../utils/getContentType';
import { NoSsr } from '@material-ui/core';
import { getAPIKey } from '../../../utils/getApiKey';
import { getDictionaryText } from '../../../utils/getDictionaryText';

const getMapTitle = (markerTitle, pageTitle, name, contentType) => {
  let mapTitle = markerTitle;
  if (contentType === EVENT_TYPE && !markerTitle) {
    mapTitle = pageTitle ? pageTitle : name;
  }
  return mapTitle;
}

const getSingleMarker = (parent, route, contentType) => {
  return [
    {
      id: '1',
      name: getMapTitle(get(parent, `${route ? route : ''}markerTitle.value`, ''), get(parent, `${route ? route : ''}pageTitle.value`, ''), get(parent, `${route ? route : ''}name.value`, ''), contentType),
      lat: parseFloat(get(parent, `${route ? route : ''}latitude.value`)),
      lng: parseFloat(get(parent, `${route ? route : ''}longitude.value`)),
      address: get(parent, `${route ? route : ''}location.value`, ''),
    },
  ];
};

const getMultipleMarkers = (locations, contentType) => {
  return locations.map((branch, i) => {
    return {
      id: (i + 2).toString(),
      name: getMapTitle(get(branch, 'fields.markerTitle.value', ''), get(branch, 'fields.pageTitle.value', ''), get(branch, 'fields.name.value', ''), contentType),
      lat: parseFloat(get(branch, 'fields.latitude.value')),
      lng: parseFloat(get(branch, 'fields.longitude.value')),
      address: get(branch, 'fields.location.value'),
    };
  });
};

const GenericMap = props => {
  const classes = useStyles(props);
  const componentName = getComponentName(props);
  const pageName = getPageName(props);
  const { t } = props;
  //const [isMapLoaded, setIsMapLoaded] = useState(true);


  const sitecoreContext = get(props, 'sitecoreContext', []);
  const language = get(sitecoreContext, 'language', LANGUAGE_CODE.DEFAULT);
  const contentType = pageContentType(props) && pageContentType(props).toLowerCase();

  const multipleLocationDetails = get(
    props,
    'fields.multipleLocationDetails',
    undefined
  );
  const latitudeChecked = get(props, 'fields.latitude.value');

  let markers;

  if (!!multipleLocationDetails || latitudeChecked) {
    if (multipleLocationDetails && multipleLocationDetails.length) {
      markers = getMultipleMarkers(multipleLocationDetails, contentType);
    } else {
      markers = getSingleMarker(props.fields, '', contentType);
    }
  } else {
    const multiLocation = get(
      sitecoreContext,
      'route.fields.multipleLocationDetails',
      undefined
    );
    if (multiLocation && multiLocation.length) {
      markers = getMultipleMarkers(multiLocation, contentType);
    } else {
      markers = getSingleMarker(sitecoreContext, 'route.fields.', contentType);
    }
  }

  const title = !!get(props, 'fields.sectionTitle.value')
    ? get(props, 'fields.sectionTitle')
    : get(sitecoreContext, 'route.fields.heading.value')
      ? get(sitecoreContext, 'route.fields.heading', undefined)
      : { value: getDictionaryText('mapTitle') };

  const helperKeys = getHelperKeysFromDictionary(t, dictionaryKeys);

  const apiKey = getAPIKey(language, sitecoreContext);

  markers = markers.length > 0 && markers.filter(item => item && item.lat && item.lng);


  // if (isMapLoaded && isLanguageEqual(language, LANGUAGE_CODE.CHINESE)) {
  //   fetch(modifyApi(BAIDU_MAP_API_URL, { apiKey }))
  //     .catch(err => {
  //       console.log("Map is not loading due to: ", err);
  //       setIsMapLoaded(false);
  //     });
  // }
  // if (!isMapLoaded) {
  //   return null;
  // }

  return (
    <Box className={classes.root} data-locator={COMPONENT_NAME}>
      <NoSsr>
        {!evalConditionForInsideChina(language) &&
          markers.length > 0 &&
          apiKey && <Grid>
            {title && (
              <Typography
                variant="h4"
                component="h2"
                className={classes.title}
              >
                <Text field={title} />
              </Typography>
            )}
            <MapViewer
              language={language}
              markers={markers}
              isRouteDirection={false}
              highlightFirstMarker={true}
              labels={helperKeys}
              apiKey={apiKey}
              componentName={componentName}
              pageName={pageName}
            />
          </Grid>}
      </NoSsr>
    </Box>
  );
};

export default withErrorBoundary(withSitecoreContext()(withNamespaces()(GenericMap)));
